import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getEmployeeCheckInfo = (axios: IAxiosInstance) => {
  return async ({
    employeeCheckID,
  }: ISchema["#/definitions/IGetEmployeeCheckInfoQueryParams"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetEmployeeCheckInfoResponse"]
    >(`/api/getEmployeeCheckInfo`, {
      params: {
        employeeCheckID,
      },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
